'use client';

import { LeaveSurvey } from '../leave-survey';
import { NewbieModal } from '../odds-table-mars/components/newbie-modal';
import { DeepInterviewManager } from '../player-deep-interview/components/deep-interview-manager';
import { PlayerSurvey } from '../player-survey';
import { BettingPreferenceModal } from '../profile/profile-panel/components/betting-preference-modal';
import { VoucherPromoModal } from '../profile/profile-panel/components/voucher-promo-modal';
import { BettingModeModal } from '../site-highlights/betting-mode-modal';
import { BoxingPromoModal } from './boxing-promo-modal';
import { RevisionNotice } from '@/jupiter/features/revision-notice';
import { PromotionActivityModal } from '../promotion-activity-modal/promotion-activity-modal';
import { WinningNotifyPopup } from '../promotion/score-challenge/components/winning-notify-popup';
import { ScoreChallengeRulesPopup } from '../promotion/score-challenge/components/rules-popup/score-challenge-rules-popup';
import { useIsAppStore } from '@/store/is-app.store';
import { NBASurvey } from '../nba-survey';
import { WinnerNotifyPopup } from '../sport-event/components/winner-notify-popup';
import { WinnerListModal } from '../sport-event/components/winner-list-modal/winner-list-modal';
import { GoldenDuelModalContainer } from '../promotion/golden-duel/components/golden-duel-modal-container';
import { WcPromotionPrizeModal } from '../wc-promotion-2026/components/wc-promotion-prize-modal';
import { WcPromotionVipModal } from '../wc-promotion-2026/components/wc-promotion-vip-modal';
import { FreeBetModal } from './free-bet-modal';
import { LoginBanner } from '../popup-banner/login-banner/login-banner';

export const PromoModals = () => {
	const isFromOldApp = useIsAppStore((state) => state.isFromOldApp);
	return (
		!isFromOldApp &&
		<>	
			<PlayerSurvey />
			<LeaveSurvey />
			<BettingModeModal />
			<RevisionNotice />
			<BettingPreferenceModal />
			<DeepInterviewManager />
			<NewbieModal />
			<BoxingPromoModal />
			<VoucherPromoModal />
			<GoldenDuelModalContainer />
			<PromotionActivityModal />
			<LoginBanner />
			<WinnerListModal />
			<WinningNotifyPopup />
			<WinnerNotifyPopup />
			<ScoreChallengeRulesPopup />
			<NBASurvey />
			<WcPromotionPrizeModal />
			<WcPromotionVipModal />
			<FreeBetModal />
		</>
	);
}
